import { useState } from 'react';
import AboutUsPopUp from 'components/AboutUsPopUp';
import './style.scss';

interface AboutUsProps {
  onClose?: () => void;
}

const AboutUs = ({ onClose }: AboutUsProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleModal = () => { setIsOpen(value => !value); };

  const handleClick = () => {
    onClose?.();
    toggleModal();
  };

  return (
    <>
      <button className="btn button-about-us" onClick={handleClick}>
        About
      </button>
      <AboutUsPopUp isOpen={isOpen} toggleModal={toggleModal} />
    </>
  );
};

export default AboutUs;
